const tabsPositionData = ['top', 'bottom', 'left'];

export default tabsPositionData;
